import React from "react"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import FacebookIcon from "@src/images/facebook.svg"
import InstagramIcon from "@src/images/instagram.svg"
import { FACEBOOK_URL, INSTAGRAM_URL } from "@utilities/constants"

interface SocialMediaProps {
  mode?: "vertical" | "horizontal"
}

const SocialMedia = ({ mode = "horizontal" }: SocialMediaProps) => {
  const redirectToFacebook = () => {
    if (window["fbq"]) {
      fbq("trackCustom", "FacebookSocialMedia", {
        path_to_redirect: FACEBOOK_URL,
      })
    }
    trackCustomEvent({
      category: "FacebookSocialMedia",
      action: "Click",
      label: "Redirect to Facebook from social media buttons",
    })
    window.open(FACEBOOK_URL)
  }

  const redirectToInstagram = () => {
    if (window["fbq"]) {
      fbq("trackCustom", "InstagramSocialMedia", {
        path_to_redirect: INSTAGRAM_URL,
      })
    }
    trackCustomEvent({
      category: "InstagramSocialMedia",
      action: "Click",
      label: "Redirect to Instagram from social media buttons",
    })
    window.open(INSTAGRAM_URL)
  }

  return (
    <div
      className={`flex ${
        mode === "vertical" ? "flex-col space-y-3" : "flex-row space-x-3"
      }`}
    >
      <button
        className="bg-white h-12 w-12 flex justify-center items-center rounded-full outline-none"
        onClick={redirectToInstagram}
      >
        <span className="sr-only">Instagram Url</span>
        <InstagramIcon className="h-5" />
      </button>
      <button
        className="bg-white h-12 w-12 flex justify-center items-center rounded-full outline-none"
        onClick={redirectToFacebook}
      >
        <span className="sr-only">Facebook Url</span>
        <FacebookIcon className="h-5" />
      </button>
    </div>
  )
}

export default SocialMedia
